import React from 'react';
import styles from './index.module.scss';

const Lock = ({ className }) => {
    return (
        <svg
            id='Group_9350'
            data-name='Group 9350'
            xmlns='http://www.w3.org/2000/svg'
            width='94'
            height='94'
            viewBox='0 0 94 94'
            className={className}
        >
            <circle
                id='Ellipse_115'
                data-name='Ellipse 115'
                cx='47'
                cy='47'
                r='47'
                className={styles.circle}
            />
            <g id='lock' transform='translate(27 21)'>
                <g id='Group_2301' data-name='Group 2301' transform='translate(0)'>
                    <path
                        id='Path_2262'
                        data-name='Path 2262'
                        d='M102.889,18H99.556V14C99.556,6.28,92.577,0,84,0S68.444,6.28,68.444,14v4H65.111A1.059,1.059,0,0,0,64,19V44a4.244,4.244,0,0,0,4.444,4H99.556A4.244,4.244,0,0,0,104,44V19A1.059,1.059,0,0,0,102.889,18ZM87.327,38.89a.939.939,0,0,1-.277.777,1.17,1.17,0,0,1-.828.333H81.778a1.17,1.17,0,0,1-.828-.333.938.938,0,0,1-.277-.777l.7-5.673A3.847,3.847,0,0,1,79.556,30a4.469,4.469,0,0,1,8.889,0,3.847,3.847,0,0,1-1.819,3.217ZM92.889,18H75.111V14c0-4.411,3.988-8,8.889-8s8.889,3.589,8.889,8Z'
                        transform='translate(-64)'
                        className={styles.icon}
                    />
                </g>
            </g>
        </svg>
    );
};

export default Lock;
